export const MEETINGS_USER_VIEWED_PAYMENT_BANNER = 'MEETINGS_USER_VIEWED_PAYMENT_BANNER';